import React, { FC, useEffect } from 'react';
import { useIntersection } from 'react-use';

type ChildrenProps = { isVisible?: boolean };

type WithVisibilityCheckProps<T extends ChildrenProps> = {
    threshold?: number;
    component: FC<T>;
};

/**
 * HOC, который позволяет отслеживать нахождение компонента во ViewPort
 * для исльзования необходимо передать компонент, который принимает isVisible,
 * и treshold - порог видимости по умолчанию 0.5
 */
export const WithVisibilityCheck =
    <T extends ChildrenProps>({
        threshold = 0.5,
        component: Component,
    }: WithVisibilityCheckProps<T>): FC<T> =>
    (props) => {
        const containerRef = React.useRef<HTMLDivElement>(null);
        const [isVisible, setIsVisible] = React.useState(false);
        const intersection = useIntersection(containerRef, {
            root: null,
            threshold,
        });
        useEffect(() => {
            setIsVisible(Boolean(intersection && intersection.intersectionRatio >= threshold));
        }, [intersection]);

        return (
            <div ref={containerRef}>
                <Component {...props} isVisible={isVisible} />
            </div>
        );
    };
